import { render } from "./LuckyRewards.vue?vue&type=template&id=51d3c73c"
import script from "./LuckyRewards.vue?vue&type=script&lang=js"
export * from "./LuckyRewards.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__